import React from 'react';

// Your logo asset - Updated from user
const LOGO_URL = '/ENSUE_LIVETRAK.webp';

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: "h-7",
    default: "h-9",
    large: "h-11",
  };

  return (
    <img 
      src={LOGO_URL}
      alt="EnsueLIVETRAK"
      className={`${sizes[size]} w-auto object-contain ${className}`}
      data-testid="logo"
    />
  );
};
